/* src/app/price-list/pages/price-list-new/price-list-new.component.scss */
/*# sourceMappingURL=price-list-new.component.css.map */
